var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container h-100 d-flex align-items-center justify-center"},[_c('img',{staticClass:"error-img",attrs:{"src":require("../../assets/icons/error.svg")}})])
}]

export { render, staticRenderFns }